<template>
    <div
        class="relative dropdown"
        :class="{ 'dropdown-open': isOpen }"
        @mouseenter="onHover(true)"
        @mouseleave="onHover(false)"
    >
        <div class="cursor-pointer toggle-container" @click.stop="toggle">
            <slot name="toggle"></slot>
            <img
                src="/default-images/whiteboard/toolbar-arrow-down.svg"
                width="15"
            />
        </div>
        <div class="menu-arrow" :class="arrowClass"></div>
        <div
            class="menu-container absolute left-[30px]"
            :class="containerClass"
        >
            <div class="menu-bridge"></div>
            <div class="menu">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, defineProps } from "vue";

const isOpen = ref(false);
const isHovered = ref(false);
const props = defineProps(["isLocked"]);

const isMobile = () => {
    return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        ) ||
        screen.availWidth < 768 ||
        screen.availHeight < 480 ||
        window.NativeApp
    );
};

function toggle() {
    /* if (props.isLocked) {
        return;
    } */
    if (isMobile()) {
        // only toggle for mobile
        isOpen.value = !isOpen.value;
    }
}

function onHover(state) {
    /* if (props.isLocked) {
        return;
    } */
    if (isMobile()) {
        return;
    }
    if (window.innerWidth > 768) {
        isHovered.value = state;
    }
}

function handleClickOutside(event) {
    const dropdown = document.querySelector(".dropdown");
    if (dropdown && !dropdown.contains(event.target)) {
        isOpen.value = false;
    }
}

onMounted(() => {
    document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
    document.removeEventListener("click", handleClickOutside);
});

const containerClass = computed(() =>
    isHovered.value || isOpen.value ? "" : "hidden"
);

const arrowClass = computed(() =>
    isHovered.value || isOpen.value ? "" : "hidden"
);
</script>

<style>
.toggle-container {
    display: flex;
    align-items: center;
    gap: 6px;
}

.dropdown {
    display: flex;
    align-items: center;
}

.dropdown .menu-container {
    transform: translateX(-50%);
    top: 55px;
}

.dropdown .menu {
    border-radius: 10px;
    border: 2px solid #e8e8e8;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.dropdown .menu .sep {
    padding-left: 2px;
    border-right: 2px dotted #c7c7c7;
    width: 1px;
    height: 30px;
}

.dropdown .menu button {
    width: 36px;
}

.menu-arrow {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 10px solid #bfbfbf;
    position: absolute;
    transform: translateX(100%);
    bottom: -24px;
}

.menu-bridge {
    top: -30px;
    width: 100%;
    height: 60px;
    z-index: -1;
    position: absolute;
}
</style>
